import { render, staticRenderFns } from "./VDistpicker.vue?vue&type=template&id=227f36be&scoped=true"
import script from "./VDistpicker.vue?vue&type=script&lang=js"
export * from "./VDistpicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "227f36be",
  null
  
)

export default component.exports